import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 内容管理接口
 */
export class ArticleControllerSvr {
    constructor() {
        this.baseurl = 'ArticleControllerSvr.assx/';
    }

    /**
     * 获取列表
     * token:String, param:ArticleQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean, resultComment:boolean, resultForward:boolean
     */
    GetArticleList(token, param, startIndex, maxSize, resultTotalCount, resultComment, resultForward){
        return request.post(this.baseurl + 'GetArticleList', Qs.stringify({ token:token, param:(typeof param === 'undefined' || param === null) ? '' : param.toString(), startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount, resultComment:resultComment, resultForward:resultForward }));
    }

    /**
     * 发布文章
     * token:String, article:Article
     */
    PublishArticle(token, article){
        return request.post(this.baseurl + 'PublishArticle', Qs.stringify({ token:token, article:(typeof article === 'undefined' || article === null) ? '' : article.toString() }));
    }

    /**
     * 修改文章
     * token:String, article:Article
     */
    ModifyArticle(token, article){
        return request.post(this.baseurl + 'ModifyArticle', Qs.stringify({ token:token, article:(typeof article === 'undefined' || article === null) ? '' : article.toString() }));
    }

    /**
     * 删除文章
     * token:String, articleId:String
     */
    DeleteArticle(token, articleId){
        return request.post(this.baseurl + 'DeleteArticle', Qs.stringify({ token:token, articleId:articleId }));
    }

    /**
     * 获取知识库列表
     * token:String, titleKeywords:String, categoryCode:String, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    GetKnowledgeBase(token, titleKeywords, categoryCode, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'GetKnowledgeBase', Qs.stringify({ token:token, titleKeywords:titleKeywords, categoryCode:categoryCode, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 
     * token:String, categoryCodes:String, keyWord:String, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
    getArticleListByCategoryCodes(token, categoryCodes, keyWord, startIndex, maxSize, resultTotalCount){
        return request.post(this.baseurl + 'getArticleListByCategoryCodes', Qs.stringify({ token:token, categoryCodes:categoryCodes, keyWord:keyWord, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
    }

    /**
     * 获取文章类型列表
     * token:String, parentId:String, option:int, startIndex:int, maxSize:int
     */
    GetCategoryList(token, parentId, option, startIndex, maxSize){
        return request.post(this.baseurl + 'GetCategoryList', Qs.stringify({ token:token, parentId:parentId, option:option, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取文章详情
     * token:String, articleId:String
     */
    GetArticleDetail(token, articleId){
        return request.post(this.baseurl + 'GetArticleDetail', Qs.stringify({ token:token, articleId:articleId }));
    }
}